export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black border-t-2 border-[#0066ff]">
      <div className="max-w-[1280px] mx-auto px-20 py-16">
        <div className="grid grid-cols-[40%_30%_30%] gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <img 
                src="https://public.readdy.ai/ai/img_res/5fc1b067-0b0c-4e27-9d09-cc15c74c3cca.png" 
                alt="SAID LTDA Logo" 
                className="h-8 w-8 object-contain"
              />
              <span className="text-2xl font-bold text-white tracking-wider">SAID LTDA</span>
            </div>
            <p className="text-[15px] text-gray-400 font-light mb-12">
              Protecting your digital life
            </p>
          </div>

          <div>
            <h3 className="text-xs font-bold text-[#0066ff] tracking-[3px] uppercase mb-6">
              QUICK LINKS
            </h3>
            <div className="space-y-5">
              <button
                onClick={() => scrollToSection('home')}
                className="block text-base text-gray-400 hover:text-white hover:underline transition-colors text-left"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('vpn-service')}
                className="block text-base text-gray-400 hover:text-white hover:underline transition-colors text-left"
              >
                VPN Service
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="block text-base text-gray-400 hover:text-white hover:underline transition-colors text-left"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-base text-gray-400 hover:text-white hover:underline transition-colors text-left"
              >
                Contact
              </button>
              <button
                onClick={() => scrollToSection('about')}
                className="block text-base text-gray-400 hover:text-white hover:underline transition-colors text-left"
              >
                About Us
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold text-[#0066ff] tracking-[3px] uppercase mb-6">
              CONTACT
            </h3>
            <div className="space-y-4">
              <a 
                href="mailto:contact@saidltda.com" 
                className="block text-base text-gray-400 hover:text-white transition-colors"
              >
                contact@saidltda.com
              </a>
              <a 
                href="tel:+16604933932" 
                className="block text-base text-gray-400 hover:text-white transition-colors"
              >
                +1 6604933932
              </a>
              <div className="text-sm text-gray-500 leading-relaxed">
                <div>CALLE 12 N 27 62</div>
                <div>YOPAL, 850001, COLOMBIA</div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-500">
              © 2025 SAID LTDA. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-gray-500 hover:text-white hover:underline transition-colors"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
